var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDreamSetlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6418 11.8L25.6464 39.3217C23.8266 38.9233 21.4152 39.1141 19.0539 39.9675C15.0168 41.4266 12.6547 44.2698 13.7781 46.318C14.9015 48.3662 19.085 48.8438 23.1221 47.3847C26.459 46.1788 28.6515 44.0272 28.6776 42.1582V17.8716H56V11.8H25.6418Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8788 13.1582C13.689 12.7617 14.3974 12.6307 15.4749 12.6308C18.3011 12.6425 20.4099 15.0453 20.4099 18.1013C20.4099 20.4145 19.1416 22.6116 16.8082 24.7104C15.5997 25.7973 14.0603 26.8704 12.9505 27.4451L12.2049 27.8311L11.4594 27.4451C10.3496 26.8704 8.81019 25.7973 7.60171 24.7104C5.26821 22.6116 4 20.4145 4 18.1013C4 15.0146 6.09072 12.6307 8.9416 12.6307C9.98134 12.6307 10.7248 12.7738 11.5496 13.1818C11.7758 13.2936 11.9916 13.4219 12.1962 13.5664C12.4118 13.4115 12.6397 13.2753 12.8788 13.1582ZM15.4737 23.0746C17.3958 21.346 18.3586 19.6778 18.3586 18.1013C18.3586 16.1957 17.1262 14.7914 15.4709 14.7845C14.6737 14.7845 14.2518 14.8625 13.7455 15.1103C13.4413 15.2593 13.173 15.4591 12.9392 15.7128L12.2084 16.5058L11.4712 15.7194C11.2425 15.4754 10.9775 15.2796 10.6755 15.1302C10.1524 14.8715 9.70063 14.7845 8.9416 14.7845C7.26305 14.7845 6.05123 16.1663 6.05123 18.1013C6.05123 19.6778 7.0141 21.346 8.93612 23.0746C9.95648 23.9923 11.2592 24.9119 12.2049 25.4274C13.1506 24.9119 14.4534 23.9923 15.4737 23.0746Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9642 36.0866V33.0508H31.7134V36.0866H52.9642Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9642 30.0149V26.9791H31.7134V30.0149H52.9642Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9642 23.9433V20.9075H31.7134V23.9433H52.9642Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreamSetlist);
export default __webpack_public_path__ + "static/media/dream-setlist.27eac659.svg";
export { ForwardRef as ReactComponent };